export default __webpack_public_path__ + "static/media/info.0b5ec0c3.svg";